import {
  ADMIN_FAIL,
  ADMIN_LOGIN_PENDING,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_AUTH_PENDING,
  ADMIN_AUTH_SUCCESS,
  ADMIN_GET_USERS_PENDING,
  ADMIN_GET_USERS_SUCCESS,
  ADMIN_GET_USER_PENDING,
  ADMIN_GET_USER_SUCCESS,
  ADMIN_UPDATE_USER_PENDING,
  ADMIN_UPDATE_USER_SUCCESS,
  ADMIN_CREATE_USER_PENDING,
  ADMIN_CREATE_USER_SUCCESS,
  ADMIN_GET_APPEALS_PENDING,
  ADMIN_GET_APPEALS_SUCCESS,
  ADMIN_GET_APPEAL_PENDING,
  ADMIN_GET_APPEAL_SUCCESS,
  ADMIN_UPDATE_APPEAL_PENDING,
  ADMIN_UPDATE_APPEAL_SUCCESS,
  ADMIN_UPDATE_APPEAL_FAIL,
  ADMIN_UPLOAD_FILE_SUCCESS,
  ADMIN_UPLOAD_FILE_PENDING,
  ADMIN_UPLOAD_FILE_FAIL,
  ADMIN_GET_RESPONSES_PENDING,
  ADMIN_GET_RESPONSES_SUCCESS,
  ADMIN_GET_RESPONSE_PENDING,
  ADMIN_GET_RESPONSE_SUCCESS,
  ADMIN_UPDATE_RESPONSE_PENDING,
  ADMIN_UPDATE_RESPONSE_SUCCESS,
  ADMIN_CREATE_RESPONSE_PENDING,
  ADMIN_CREATE_RESPONSE_SUCCESS,
  ADMIN_CREATE_REPLY_SUCCESS,
  ADMIN_CREATE_REPLY_PENDING,
  ADMIN_TOGGLE_RESPONSE_MODAL,
  ADMIN_UPDATE_REPLY_FIELD_VALUE,
  ADMIN_CONCAT_REPLY_FIELD_VALUE,
  ADMIN_TOGGLE_EMAIL_MODAL,
  ADMIN_UPDATE_EMAIL_FIELD_VALUE,
  ADMIN_ADD_TEMPLATE_RICH_EDITOR,
  ADMIN_UPDATE_STATUS_SUCCESS,
  ADMIN_UPDATE_STATUS_PENDING,
  ADMIN_GET_EMAILS_PENDING,
  ADMIN_GET_EMAILS_SUCCESS,
  ADMIN_GET_EMAIL_PENDING,
  ADMIN_GET_EMAIL_SUCCESS,
  ADMIN_UPDATE_EMAIL_PENDING,
  ADMIN_UPDATE_EMAIL_SUCCESS,
  ADMIN_CREATE_EMAIL_PENDING,
  ADMIN_CREATE_EMAIL_SUCCESS,
  ADMIN_UPDATE_EMAIL_SUBJECT_VALUE,
  ADMIN_SEND_EMAIL_SUCCESS,
  ADMIN_SEND_EMAIL_PENDING,
  ADMIN_CREATE_PDF_SUCCESS,
  ADMIN_CREATE_PDF_PENDING,
  ADMIN_SEND_POST_SUCCESS,
  ADMIN_SEND_POST_PENDING,
  ADMIN_GET_ACTIONS_PENDING,
  ADMIN_GET_ACTIONS_SUCCESS,
  ADMIN_GET_REASONS_PENDING,
  ADMIN_GET_REASONS_SUCCESS,
  ADMIN_GET_REASON_PENDING,
  ADMIN_GET_REASON_SUCCESS,
  ADMIN_UPDATE_REASON_PENDING,
  ADMIN_UPDATE_REASON_SUCCESS,
  ADMIN_CREATE_REASON_PENDING,
  ADMIN_CREATE_REASON_SUCCESS,
  CLEAR_RICH_FIELD_PENDING,
  CLEAR_RICH_FIELD_SUCCESS

} from '../actions/adminActions'

const initialState = {
  loading: false,
  auth: null,
  users: null,
  user: null,
  submitting: false,
  pdfing: false,
  mailing: false,
  deleting: false,
  posting: false,
  appeals: null,
  appeal: {
    reg: null,
    submitBy: null,
    files: null,
    replies: null
  },
  responses: null,
  response: null,
  emails: null,
  email: null,
  responseModal: false,
  replyValue: '',
  subjectValue: '',
  emailModal: false,
  emailValue: '',
  pdf: null,
  actions: [],
  token: null,
  pin: null,
  reasons: [],
  reason: null,
  templateValue: null,
  clearRichField: false,
  replyModal: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_LOGIN_PENDING:
    case ADMIN_AUTH_PENDING:
    case ADMIN_GET_USERS_PENDING:
    case ADMIN_GET_RESPONSES_PENDING:
    case ADMIN_GET_EMAILS_PENDING:
    case ADMIN_GET_APPEALS_PENDING:
    case ADMIN_GET_REASONS_PENDING:
      return {
        ...state,
        loading: true
      }
    case ADMIN_CREATE_RESPONSE_PENDING:
    case ADMIN_CREATE_EMAIL_PENDING:
    case ADMIN_CREATE_USER_PENDING:
    case ADMIN_UPDATE_USER_PENDING:
    case ADMIN_CREATE_REASON_PENDING:
    case ADMIN_UPDATE_REASON_PENDING:
    case ADMIN_UPDATE_RESPONSE_PENDING:
    case ADMIN_UPDATE_EMAIL_PENDING:
    case ADMIN_CREATE_REPLY_PENDING:
    case ADMIN_SEND_EMAIL_PENDING:
      return {
        ...state,
        submitting: true
      }
    case ADMIN_CREATE_PDF_PENDING:
      return {
        ...state,
        pdfing: true,
        pdf: null
      }
    case ADMIN_CREATE_PDF_SUCCESS:
      return {
        ...state,
        pdfing: false,
        pdf: action.pdf
      }
    case ADMIN_SEND_POST_PENDING:
      return {
        ...state,
        posting: true
      }
    case ADMIN_SEND_POST_SUCCESS:
      return {
        ...state,
        posting: false
      }
    case ADMIN_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case ADMIN_AUTH_SUCCESS:
      return {
        ...state,
        loading: false,
        auth: action.item,
        token: action.token,
        pin: action.pin
      }
    case ADMIN_GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.data
      }
    case ADMIN_GET_REASONS_SUCCESS:
      return {
        ...state,
        loading: false,
        reasons: action.data
      }
    case ADMIN_GET_RESPONSES_SUCCESS:
      return {
        ...state,
        loading: false,
        responses: action.data
      }
    case ADMIN_GET_RESPONSE_PENDING:
      return {
        ...state,
        loading: true,
        response: null
      }
    case ADMIN_GET_RESPONSE_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.data
      }
    case ADMIN_GET_EMAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        emails: action.data
      }
    case ADMIN_GET_EMAIL_PENDING:
      return {
        ...state,
        loading: true,
        email: null
      }
    case ADMIN_GET_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        email: action.data
      }
    case ADMIN_GET_APPEALS_SUCCESS:
      return {
        ...state,
        loading: false,
        appeals: action.data,
        replyValue: '', // reset reply value when appeals loaded
        emailValue: '',
        subjectValue: '',
        templateValue: null
      }
    case ADMIN_GET_APPEAL_SUCCESS:
      return {
        ...state,
        loading: false,
        appeal: action.data,
        templateValue: null
      }
    case ADMIN_GET_APPEAL_PENDING:
      return {
        ...state,
        loading: true,
        appeal: {
          reg: '',
          submitBy: null,
          files: null,
          replies: null
        }
      }
    case ADMIN_CREATE_REPLY_SUCCESS:
      return {
        ...state,
        submitting: false,
        replyValue: ''
      }
    case ADMIN_SEND_EMAIL_SUCCESS:
      return {
        ...state,
        submitting: false,
        emailValue: '',
        subjectValue: ''
      }
    case ADMIN_GET_USER_PENDING:
      return {
        ...state,
        loading: true,
        user: null
      }
    case ADMIN_GET_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.data
      }
    case ADMIN_GET_REASON_PENDING:
      return {
        ...state,
        loading: true,
        reason: null
      }
    case ADMIN_GET_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
        reason: action.data
      }
    case ADMIN_GET_ACTIONS_PENDING:
      return {
        ...state,
        actions: []
      }
    case ADMIN_GET_ACTIONS_SUCCESS:
      return {
        ...state,
        actions: action.data
      }
    case ADMIN_UPDATE_USER_SUCCESS:
    case ADMIN_CREATE_USER_SUCCESS:
    case ADMIN_UPDATE_REASON_SUCCESS:
    case ADMIN_CREATE_REASON_SUCCESS:
    case ADMIN_CREATE_RESPONSE_SUCCESS:
    case ADMIN_UPDATE_RESPONSE_SUCCESS:
    case ADMIN_CREATE_EMAIL_SUCCESS:
    case ADMIN_UPDATE_EMAIL_SUCCESS:
      return {
        ...state,
        submitting: false
      }
    case ADMIN_FAIL:
      return {
        ...state,
        loading: false,
        submitting: false,
        deleting: false,
        pdfing: false,
        mailing: false,
        posting: false
      }
    case ADMIN_UPDATE_APPEAL_SUCCESS:
      return {
        ...state,
        appeal: action.data,
        error: null,
        loading: false,
        appealDetail_loading: false,
        details_loading: false,
        grounds_loading: false
      }
    case ADMIN_UPDATE_APPEAL_PENDING:
      return {
        ...state,
        error: null,
        loading: true,
        appealDetail_loading: (action.id === 'appealDetail'),
        details_loading: (action.id === 'details'),
        grounds_loading: (action.id === 'grounds')
      }
    case ADMIN_UPDATE_APPEAL_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false,
        appealDetail_loading: false,
        details_loading: false,
        grounds_loading: false

      }
    case ADMIN_UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        error: null,
        upload_loading: false
      }
    case ADMIN_UPLOAD_FILE_PENDING:
      return {
        ...state,
        error: null,
        upload_loading: true
      }
    case ADMIN_UPLOAD_FILE_FAIL:
      return {
        ...state,
        error: action.error,
        upload_loading: false
      }
    case ADMIN_TOGGLE_RESPONSE_MODAL:
      return {
        ...state,
        responseModal: !state.responseModal
      }
    case ADMIN_TOGGLE_EMAIL_MODAL:
      return {
        ...state,
        emailModal: !state.emailModal
      }
    case ADMIN_UPDATE_REPLY_FIELD_VALUE:
      return {
        ...state,
        replyValue: action.value
      }
    case ADMIN_CONCAT_REPLY_FIELD_VALUE:
      return {
        ...state,
        replyValue: state.replyValue + ' ' + action.value
      }
    case ADMIN_UPDATE_EMAIL_FIELD_VALUE:
      return {
        ...state,
        emailValue: action.value
      }
    case ADMIN_UPDATE_EMAIL_SUBJECT_VALUE:
      return {
        ...state,
        subjectValue: action.value
      }
    case ADMIN_ADD_TEMPLATE_RICH_EDITOR:
      return {
        ...state,
        templateValue: action.value,
        subjectValue: action.subject
      }
    case ADMIN_UPDATE_STATUS_PENDING:
      return {
        ...state,
        submitting: true
      }
    case ADMIN_UPDATE_STATUS_SUCCESS:
      return {
        ...state,
        submitting: false
      }
    case CLEAR_RICH_FIELD_PENDING:
      return {
        ...state,
        clearRichField: true
      }
    case CLEAR_RICH_FIELD_SUCCESS:
      return {
        ...state,
        clearRichField: false,
        emailValue: ''
      }
    case '/admin/TOGGLE_REPLY_MODAL':
      return {
        ...state,
        replyModal: (action.value === false) ? action.value : !state.replyModal
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/adminReducers.js